<template>
  <div>
    <div class="cn">{{cn}}</div>
    <div class="en">{{en}}</div>
  </div>
</template>

<script>
export default {
  props: {
    cn: {
      type: String,
    },
    en: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.cn,
.en {
  text-align: center;
}
.cn {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.88);
}
.en {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.48);
}
</style>
